import { getTestId } from '@airtel/air-design-system';
var MULTI_SECTION_MOCK_HEADERLIST = [{
  title: '5 GB data',
  iconName: 'MobileDataIcon'
}, {
  title: '100 mins/day',
  iconName: 'MobileDataIcon'
}, {
  title: '20 SMS ',
  iconName: 'MobileDataIcon'
}];
var MULTI_SECTION_MOCK_CONTENTLIST = [{
  title: 'A',
  content: ['Albania', 'Australia', 'Austria', 'Azerbaijan']
}, {
  title: 'B',
  content: ['Bahamas', 'Belarus', 'Belgium', 'Brunei', 'Bulgaria']
}, {
  title: 'C',
  content: ['Cambodia', 'Canada', 'China', 'Croatia', 'Cyprus', 'Czech Republic']
}, {
  title: 'D',
  content: ['Denmark']
}, {
  title: 'E',
  content: ['Egypt', 'Estonia']
}, {
  title: 'F',
  content: ['Faroe Islands', 'Finland', 'France']
}, {
  title: 'G',
  content: ['Georgia', 'Germany', 'Gibraltar', 'Greece', 'Guernsey']
}, {
  title: 'H',
  content: ['Hong Kong', 'Hungary']
}, {
  title: 'I',
  content: ['Iceland', 'Indonesia', 'Ireland', 'Isle of Mann', 'Israel', 'Italy']
}, {
  title: 'J',
  content: ['Japan']
}, {
  title: 'K',
  content: ['Korea']
}, {
  title: 'L',
  content: ['Latvia', 'Liechtenstin', 'Lithuania', 'Luxembourg']
}, {
  title: 'M',
  content: ['Macau', 'Macedonia', 'Malaysia', 'Malta', 'Mauritius', 'Mexico', 'Moldova', 'Monaco', 'Mongolia', 'Montenegro']
}, {
  title: 'N',
  content: ['Netherlands', 'New Zealand', 'Norway']
}, {
  title: 'P',
  content: ['Poland', 'Portugal']
}, {
  title: 'R',
  content: ['Romania']
}, {
  title: 'S',
  content: ['Senegal', 'Serbia', 'Singapore', 'Slovenia', 'Spain', 'Sweden', 'Switzerland']
}, {
  title: 'T',
  content: ['Taiwan', 'Thailand', 'Timor', 'Turkey']
}, {
  title: 'U',
  content: ['Ukraine', 'United Kingdom', 'USA']
}, {
  title: 'V',
  content: ['Vietnam']
}];
export var defaultProps = Object.assign({
  numberOfColumn: 3,
  headerList: MULTI_SECTION_MOCK_HEADERLIST,
  contentList: MULTI_SECTION_MOCK_CONTENTLIST
}, getTestId('ChoronologicalListWidgetContainer'));